import React from 'react';
import './about.css';

function About() {
    return (
        <div>
            <h1>About</h1>
            <p class="aboutParagraph">AnchorTechSolutions aims to revolutionize the commercial shipping industry.
            By creating a software that makes it easier to produce mooring plans which is a tedious job at the moment
            we make life easier. This will create a possiility to open up a lot of more time for 
            the person responsible of creating these plans which could be used on other useful areas.</p>

            <p>The goals of the project are a set of core functionalities for the software:</p>
            <ul>
            <li>G1. A Working prototype of the software that can export a mooring plan in PDF format. </li>
            <li>G2. A GUI for easy use of software.</li>
            <li>G3. Implementation of features that are a must have in a mooring plan.</li>
            <ul>
            <li>G3.1. Show where the gangway is</li>
            <li>G3.2. Show mooring lines.</li>
            <li>G3.3 Draw the boat.</li>
            <li>G3.4 Draw berth.</li>
            <li>G3.5 Draw bollards, winches and other necessary parts.</li>
            <li>G3.6 Insert tables with information.</li>
            </ul>  
            <li>G4. Thorough documentation and testing.</li>
            <li>G5. Detailed and timely progress reports.</li>
            <li>G6. Write a detailed report for the project and software.</li>
            <li>G3.5 Draw bollards, winches and other necessary parts.</li>
            <li>G7. Deploy the software. (This is if we have time)</li>
            </ul> 

        </div>
    );
}

export default About;
